var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlightBulbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 43 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .054)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: 43,
    height: 43,
    rx: 21.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F6F8FA",
    cx: 21.686,
    cy: 21.693,
    rx: 13.134,
    ry: 13.139
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 26.77c.506-.006 1.02.004 1.527.004 1.635 0 2.268-.25 2.268.849 0 1.535-.63.853-.873 1.594-.303.923-.435.773-1.476.775-1.149.002-1.077.1-1.415-.835-.157-.436-.282-.172-.606-.53-.264-.293-.253-.668-.253-1.087 0-.64.218-.765.827-.77M23.34 15.987c2.216.488 1.188 2.94 2.223 2.653.504-.268.402-.808.251-1.399-.224-.88-.94-1.709-1.76-2.036-1.566-.624-1.952.573-.714.782",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 26.248 21.83 c -0.887 1.496 -1.18 0.727 -1.904 3.478 c -0.225 0.853 -1.072 0.675 -1.916 0.675 c -2.324 0 -2.575 0.313 -2.884 -1.082 C 19.097 22.883 17.693 22.517 17.211 20.633 C 15.624 14.428 23.419 11.58 26.28 16.5 c 0.978 1.68 0.95 3.675 -0.033 5.33",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightBulbIcon);
export default __webpack_public_path__ + "static/media/highlightBulbIcon.c76e61afd3027fb194c3fbd520458fe1.svg";
export { ForwardRef as ReactComponent };